<template>
  <div class="newsletterBlock">
    <div class="wrapper text-center">
      <div class="newsletterBlock__image lazyload" />
      <div class="newsletterBlock__content">
        <h4>Your keys to our house</h4>
        <p>Sign up to our newsletter for beautiful villas, destinations and things to do</p>
        <form tabindex="0" class="signupInput-light__form" @submit.prevent>
          <input
            id="su-email"
            ref="emailInput"
            v-model="userEmail"
            type="email"
            name="email"
            tabindex="0"
            placeholder="Enter email address"
            aria-label="Email address"
          >
          <button @click="navigateToNewsletterSignup">
            <img src="../assets/img/src/icons/curved-arrow-right-dark.svg" alt="Arrow Right" class="signupInput-light__icon lazyload">
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userEmail: '',
    };
  },
  methods: {
    navigateToNewsletterSignup(e) {
      e.preventDefault();
      let qstring = (this.userEmail.length > 0) ? qstring = `?email=${this.userEmail}` : '';
      $router.push({ path: this.$store.getters['applinks/getLink']('page', 936).url + qstring });
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings/_config.scss";

.newsletterBlock {
  background-color: $yellowStone;
  height: 100%;
  @media screen and (min-width: 1023px) {
    height: 640px;
  }
  .wrapper {
    @media screen and (min-width: 1023px) {
      max-width: 1600px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      height: 100%;
    }
  }
  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    max-width: 560px;
    padding: 1em;
    h4 {
      font-size: 32px;
      font-family: $font-family-editorial;
      @media screen and (min-width: 1023px) {
        font-size: 48px;
      }
    }
    .signupInput-light {
      &__form {
        width: 100%;
        position: relative;
        height: 48px;
        input {
          width: 100%;
          background-color: $stoneWhite;
          border: $stoneWhite;
          color: $darkBlack;
        }
      }
      &-box {
        padding-bottom: 120px;
      }
      &__icon {
        position: absolute;
        top: 16px;
        right: 16px;
      }
    }
  }
  &__image {
    background-image: url('../assets/img/src/illustrations/window.svg');
    background-size: contain;
    min-height: 388px;
    background-position: center;
  }
}

</style>
